module.exports = __webpack_public_path__ + "static/img/MANCHESTER_MAPLE.78f7e2b.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/materials/Frendel/MANCHESTER_MAPLE.jpg
// module id = 6B7l
// module chunks = 0